export default __webpack_public_path__ + "static/media/P.e2dc569d.svg";